import { usePrintsUiStore } from '../stores';
import { useEffectOnce } from './use-effect-once';

// Opens the photo loader modal by calling `addPhotos` prop on first render when ready,
// no photos exist, and no album import is in progress.
export const useAutoOpenPhotoLoader = ({
  hasPhotos,
  uploadFromGalleryListenerUrl,
  addPhotos,
  hasAlbumImportPending = false,
}) => {
  const ready = usePrintsUiStore((state) => state.ready);
  const currentlyLoading = usePrintsUiStore((state) => state.currentlyLoading);

  useEffectOnce(
    ([
      ,
      hasPhotosDep,
      currentlyLoadingDep,
      addPhotosDep,
      galleryUrlDep,
      albumImportPendingDep,
    ]) => {
      if (
        !hasPhotosDep &&
        !currentlyLoadingDep &&
        !galleryUrlDep &&
        !albumImportPendingDep
      ) {
        addPhotosDep();
      }
    },
    [
      ready,
      hasPhotos,
      currentlyLoading,
      addPhotos,
      uploadFromGalleryListenerUrl,
      hasAlbumImportPending,
    ],
    ([readyDep]) => readyDep === true,
  );
};
